<template>
  <div class="dettaglio-ordine">
    <div class="header-tab row row-custom">
      <div class="my-label col-24 no-padding">
        {{ $t('dettaglioOrdine.ordine').toUpperCase() }} {{ ordine.numOrd }}
      </div>
      <div class="sotto-label col-24 no-padding">
        ({{ $t('dettaglioOrdine.del') }} {{ moment(ordine.datOrd, 'DDMMYYYY').format('DD/MM/YYYY') }})
      </div>
    </div>

    <div class="testata-ordine row row-custom" v-loading="loading">
      <div class="colonna col-xl-8 col-lg-12 col-24">

        <div class="blocco">
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.societa') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.codSoc | formatString }}  {{ testata.desSoc | formatSecondString }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.magazzino') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.codMag | formatString }}  {{ testata.desMag | formatSecondString }}
            </div>
          </div>
        </div>

        <div class="blocco secondo-blocco">
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.fornitore') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.desFor | formatString }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.oggettoFornitura') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.oggFornit | formatString }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.codSpedizione') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.codSpe | formatString }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.descSpedizione') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.desSpe | formatString }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.interlocutore') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.interloc | formatString }}
            </div>
          </div>
        </div>

      </div>

      <div class="colonna col-xl-8 col-lg-12 col-24 no-padding">

        <div class="blocco">
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.impiegato') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.codImp | formatString }} {{ testata.desImp | formatSecondString }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.telefono') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.telImp | formatString }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.email') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.mailImp | formatString }}
            </div>
          </div>
        </div>

        <div class="blocco secondo-blocco">
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.codResa') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.codResa | formatString }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.desResa') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.desResa | formatString }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.codPagamento') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.codPag | formatString }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.desPagamento') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.desPag | formatString }}
            </div>
          </div>
        </div>

      </div>

      <div class="colonna col-xl-8 d-block d-lg-none d-xl-block col-24">

        <div class="blocco">
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.variante') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.variante | formatString }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.dataVariante') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ testata.datVar ? moment(testata.datVar, 'DDMMYYYY').format('DD/MM/YYYY') : '-' }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.dataAutorizzazione') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              {{ moment(testata.datAut, 'DDMMYYYY').format('DD/MM/YYYY') }}
            </div>
          </div>
        </div>

        <div class="blocco secondo-blocco col-lg-24 col-24 no-padding">
          <div class="elemento row row-custom">
            <div class="testata-label col-md-11 col-12">
              {{ $t('dettaglioOrdine.ingressoStab') }}
            </div>
            <div class="testata-value col-md-13 col-12">
              <icon name="riv-tick" class="icona" scale="1" v-if="(testata.ingrStab === 'S')"></icon>
              <span v-else> {{ '-' }} </span>
            </div>
          </div>
        </div>

      </div>

      <div class="colonna d-xl-none col-lg-24 d-none d-lg-block no-padding colonna-md">
        <div class="row row-custom">
          <div class="blocco col-12 no-padding">
            <div class="elemento row row-custom">
              <div class="testata-label col-md-11">
                {{ $t('dettaglioOrdine.variante') }}
              </div>
              <div class="testata-value col-md-13">
                {{ testata.variante | formatString }}
              </div>
            </div>
            <div class="elemento row row-custom">
              <div class="testata-label col-md-11">
                {{ $t('dettaglioOrdine.dataVariante') }}
              </div>
              <div class="testata-value col-md-13">
                {{ moment(testata.datVar, 'DDMMYYYY').format('DD/MM/YYYY') }}
              </div>
            </div>
            <div class="elemento row row-custom">
              <div class="testata-label col-md-11">
                {{ $t('dettaglioOrdine.dataAutorizzazione') }}
              </div>
              <div class="testata-value col-md-13">
                {{ moment(testata.datAut, 'DDMMYYYY').format('DD/MM/YYYY') }}
              </div>
            </div>
          </div>
          <div class="blocco col-12 no-padding">
            <div class="elemento row row-custom">
              <div class="testata-label col-md-11">
                {{ $t('dettaglioOrdine.ingressoStab') }}
              </div>
              <div class="testata-value col-md-13">
                <icon class="icona" name="riv-tick" scale="1" v-if="(testata.ingrStab === 'S')"></icon>
                <span v-else> {{ '-' }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-tabs v-model="tabActive" type="card" class="col-24 custom-tabs" v-loading="loading">
      <el-tab-pane :key="($t('dettaglioOrdine.prodotti'))">
        <div style="width: 200px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('dettaglioOrdine.prodotti').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>
        <el-table :data="prodotti" class="col-24 no-padding custom-table">
          <el-table-column
            prop="codPos"
            label="#"
            width="50">
          </el-table-column>
          <el-table-column
            prop="codProd"
            :label="$t('dettaglioOrdine.prodotto')"
            width="110">
          </el-table-column>
          <el-table-column
            prop="desProd"
            :label="$t('dettaglioOrdine.descrizione')"
            min-width="200">
          </el-table-column>
          <el-table-column
            header-align="center" align="center"
            :label="$t('dettaglioOrdine.dataConsegna')"
            width="150">

            <template slot-scope="scope">
              <div class="name-wrapper ggScaduto" v-if="((returnGgScaduto(scope.row.datCons) > 0 || returnGgScaduto(scope.row.datCons) === '99+') && (parseFloat(scope.row.qtaRes) > 0))">
                <el-tooltip :content="($t('dettaglioOrdine.scadutoDa') + ' ' + returnGgScadutoTooltip(scope.row.datCons) + ' ' + $t('dettaglioOrdine.giorni'))" placement="top">
                  <el-badge :value="(returnGgScaduto(scope.row.datCons))" class="item">
                    {{ moment(scope.row.datCons, 'DDMMYYYY').format('DD/MM/YYYY') }}
                  </el-badge>
                </el-tooltip>
              </div>
              <div class="name-wrapper" v-else>
                {{ moment(scope.row.datCons, 'DDMMYYYY').format('DD/MM/YYYY') }}
              </div>
            </template>

          </el-table-column>
          <el-table-column
            prop="codUmis" header-align="center" align="center"
            :label="$t('dettaglioOrdine.uMis')"
            width="60">
          </el-table-column>
          <el-table-column
            header-align="left" align="left"
            :label="$t('dettaglioOrdine.imballo')"
            width="100">

            <template slot-scope="scope">
              <div class="name-wrapper">
                {{ (scope.row.desImb.length > 8) ? (scope.row.desImb.substr(0, 8) + '...') : scope.row.desImb }}
              </div>
            </template>

          </el-table-column>
          <el-table-column
            prop="qtaOrd" header-align="right" align="right"
            :label="$t('dettaglioOrdine.ordinato')"
            min-width="55">
          </el-table-column>
          <el-table-column
            prop="qtaCons" header-align="right" align="right"
            :label="$t('dettaglioOrdine.consegnato')"
            min-width="55">
          </el-table-column>
          <el-table-column
            prop="qtaRes" header-align="right" align="right"
            :label="$t('dettaglioOrdine.residuo')"
            min-width="55">
          </el-table-column>
        </el-table>

        <el-pagination v-if="(tabProdotti.nrPages > 1)" :current-page="tabProdotti.currentPage"
                       background class="col-24 custom-pagination"
                       layout="prev, pager, next"
                       :total="tabProdotti.nrItems"
                       :page-size="tabProdotti.pag_for"
                       @current-change="changePageProdotti">
        </el-pagination>

      </el-tab-pane>
      <el-tab-pane :key="($t('dettaglioOrdine.buoniDiRitiro'))">
        <div style="width: 200px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('dettaglioOrdine.buoniRitiro').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>
        <el-table :data="buonirit" class="col-24 no-padding custom-table">
          <el-table-column
            prop="numBuono" align="center" header-align="center"
            :label="$t('dettaglioOrdine.nrBuono')"
            min-width="90">
          </el-table-column>
          <el-table-column align="center" header-align="center"
            :label="$t('dettaglioOrdine.dataInserimento')"
            min-width="120">

            <template slot-scope="scope">
              <div class="name-wrapper">
                {{ moment(scope.row.datBuono, 'DDMMYYYY').format('DD/MM/YYYY') }}
              </div>
            </template>

          </el-table-column>
          <el-table-column
            :label="$t('dettaglioOrdine.indirizzoRitiroMerce')"
            min-width="200">

            <template slot-scope="scope">
              <div class="name-wrapper">
                {{ scope.row.indRit + ' - ' + scope.row.capRit + ', ' + scope.row.locRit + ' - ' + scope.row.provRit }}
              </div>
            </template>

          </el-table-column>
          <el-table-column
            prop="numColli" align="right" header-align="right"
            :label="$t('dettaglioOrdine.nrColli')"
            min-width="70">
          </el-table-column>
          <el-table-column
            prop="totPeso" align="right" header-align="right"
            :label="$t('dettaglioOrdine.totalePeso') + ' (Kg)'"
            min-width="110">
          </el-table-column>
          <el-table-column align="center"
            width="100">

            <template slot-scope="scope">
              <div class="name-wrapper">
                <icon name="riv-pdf_RGB" style="color:dimgray" scale="1.4" class="pointer" @click.native="getBuonoRit(scope.row)" />
              </div>
            </template>

          </el-table-column>

        </el-table>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
  import {bus} from '@/components/Bus.js'
  import moment from 'moment'

  export default {
    name: 'DettaglioOrdine',
    filters: {
      formatString: function (string) {
        if (string === '' || string === undefined) {
          return '-'
        }
        return string
      },
      formatSecondString: function (string) {
        if (string === '' || string === undefined) {
          return ' '
        }
        return string
      }
    },
    i18n: {
      messages: {
        it_IT: {
          dettaglioOrdine: {
            societa: 'Società',
            magazzino: 'Stabilimento',
            fornitore: 'Fornitore',
            oggettoFornitura: 'Oggetto Fornitura',
            codSpedizione: 'Cod. Spedizione',
            descSpedizione: 'Desc. Spedizione',
            interlocutore: 'Interlocutore',
            impiegato: 'Impiegato',
            telefono: 'Telefono',
            email: 'Mail',
            codResa: 'Cod. Resa',
            desResa: 'Desc. Resa',
            codPagamento: 'Cod. Pagamento',
            desPagamento: 'Desc. Pagamento',
            variante: 'Variante',
            dataVariante: 'Data Variante',
            dataAutorizzazione: 'Data Autorizzazione',
            ingressoStab: 'Ingresso Stab.',
            ordine: 'Ordine',
            del: 'del',
            prodotti: 'Prodotti',
            buoniRitiro: 'Buoni di Ritiro',
            posizione: 'Posizione',
            prodotto: 'Prodotto',
            descrizione: 'Descrizione',
            dataConsegna: 'Data consegna',
            uMis: 'UM',
            imballo: 'Imballo',
            ordinato: 'Ordinato',
            consegnato: 'Consegnato',
            residuo: 'Residuo',
            nrBuono: 'Num. Buono',
            dataInserimento: 'Data Inserimento',
            indirizzoRitiroMerce: 'Indirizzo Ritiro Merce',
            nrColli: 'Nr. Colli',
            totalePeso: 'Peso Totale',
            scadutoDa: 'Scaduto da',
            giorni: 'giorni'
          }
        },
        fr_FR: {
          dettaglioOrdine: {
            societa: 'Société',
            magazzino: 'Usine',
            fornitore: 'Fournisseur',
            oggettoFornitura: 'Objet d\'approvisionnement',
            codSpedizione: 'Code de Livraison',
            descSpedizione: 'Desc. Livraison',
            interlocutore: 'Contact',
            impiegato: 'Employé',
            telefono: 'Téléphone',
            email: 'E-Mail',
            codResa: 'Code de Retour',
            desResa: 'Desc. de Retour',
            codPagamento: 'Cod. Paiement',
            desPagamento: 'Desc. Paiement',
            variante: 'Variante',
            dataVariante: 'Date de la Variante',
            dataAutorizzazione: 'Date d\'Autorisation',
            ingressoStab: 'Entrée d\'Usine',
            ordine: 'Commande',
            del: 'de',
            prodotti: 'Produits',
            buoniRitiro: 'Bons de retrait',
            posizione: 'Emplacement',
            prodotto: 'Produit',
            descrizione: 'Description',
            dataConsegna: 'Date de livraison',
            uMis: 'UM',
            imballo: 'Emballage',
            ordinato: 'Ordonné',
            consegnato: 'Livré',
            residuo: 'Résiduel',
            nrBuono: 'Bon',
            dataInserimento: 'Date d\'entrée',
            indirizzoRitiroMerce: 'Articles de retrait Adresse',
            nrColli: 'Paquets',
            totalePeso: 'Poids Total',
            scadutoDa: 'Expiré par',
            giorni: 'journées'
          }
        },
        es_ES: {
          dettaglioOrdine: {
            societa: 'Empresa',
            magazzino: 'Fábrica',
            fornitore: 'Proveedor',
            oggettoFornitura: 'Objeto de suministro',
            codSpedizione: 'Forma de envío',
            descSpedizione: 'Descripción envío',
            interlocutore: 'Contacto',
            impiegato: 'Empleado',
            telefono: 'Teléfono',
            email: 'E-mail',
            codResa: 'Envío',
            desResa: 'Descripción Retorno',
            codPagamento: 'Forma de Pago',
            desPagamento: 'Descripción Pago',
            variante: 'Variante',
            dataVariante: 'Fecha Variante',
            dataAutorizzazione: 'Fecha Autorización',
            ingressoStab: 'Entrada Fábrica',
            ordine: 'Pedido',
            del: 'del',
            prodotti: 'Productos',
            buoniRitiro: 'Aviso de Retirada',
            posizione: 'Ubicación',
            prodotto: 'Producto',
            descrizione: 'Descripción',
            dataConsegna: 'Fecha de entrega',
            uMis: 'UM',
            imballo: 'Embalaje',
            ordinato: 'Ordenado',
            consegnato: 'Liberado',
            residuo: 'Residual',
            nrBuono: 'Ref.',
            dataInserimento: 'Fecha de entrada',
            indirizzoRitiroMerce: 'Dirección de Retiro de Bienes',
            nrColli: 'Paquetes',
            totalePeso: 'Peso Total',
            scadutoDa: 'Expirado por',
            giorni: 'días'
          }
        },
        de_DE: {
          dettaglioOrdine: {
            societa: 'Unternehmen',
            magazzino: 'Werk',
            fornitore: 'Lieferant',
            oggettoFornitura: 'Versorgungsobjekt',
            codSpedizione: 'Versandcode',
            descSpedizione: 'Versandbeschreibung',
            interlocutore: 'Kontakt',
            impiegato: 'Ersteller',
            telefono: 'Telefon',
            email: 'E-Mail',
            codResa: 'Übergabecode',
            desResa: 'Beschreibung',
            codPagamento: 'Zahlungscode',
            desPagamento: 'Zahlungsbeschreibung',
            variante: 'Änderung',
            dataVariante: 'Änderungsdatum',
            dataAutorizzazione: 'Autorisierungsdatum',
            ingressoStab: 'Werkeintrittserlaubnis',
            ordine: 'Bestellnr.',
            del: 'vom',
            prodotti: 'Produkte',
            buoniRitiro: 'Abholungsavis',
            posizione: 'Lage',
            prodotto: 'Produkt',
            descrizione: 'Beschreibung',
            dataConsegna: 'Lieferdatum',
            uMis: 'Maßeinheit',
            imballo: 'Verpackung',
            ordinato: 'Bestellt',
            consegnato: 'Geliefert',
            residuo: 'Residual',
            nrBuono: 'Gutschein',
            dataInserimento: 'Eintrittsdatum',
            indirizzoRitiroMerce: 'Adresse Widerruf Waren',
            nrColli: 'Pakete',
            totalePeso: 'Gesamtgewicht',
            scadutoDa: 'Abgelaufen von',
            giorni: 'tage'
          }
        },
        en_GB: {
          dettaglioOrdine: {
            societa: 'Society',
            magazzino: 'Factory',
            fornitore: 'Supplier',
            oggettoFornitura: 'Supply Object',
            codSpedizione: 'Shipping Code',
            descSpedizione: 'Shipping Description',
            interlocutore: 'Contact',
            impiegato: 'Employee',
            telefono: 'Phone',
            email: 'e-mail',
            codResa: 'Return Code',
            desResa: 'Return Description',
            codPagamento: 'Payment Code',
            desPagamento: 'Payment Description',
            variante: 'Variant',
            dataVariante: 'Variant Date',
            dataAutorizzazione: 'Authorization Date',
            ingressoStab: 'Factory Entrance',
            ordine: 'Order',
            del: 'of',
            prodotti: 'Products',
            buoniRitiro: 'Withdrawal vouchers',
            posizione: 'Position',
            prodotto: 'Product',
            descrizione: 'Description',
            dataConsegna: 'Delivery date',
            uMis: 'UM',
            imballo: 'Packaging',
            ordinato: 'Ordered',
            consegnato: 'Delivered',
            residuo: 'Residue',
            nrBuono: 'Voucher',
            dataInserimento: 'Entry Date',
            indirizzoRitiroMerce: 'Address Withdrawal Goods',
            nrColli: 'Packages',
            totalePeso: 'Total Weight',
            scadutoDa: 'Expired by',
            giorni: 'days'
          }
        }
      }
    },
    props: {
      prefixApp: {
        type: String
      }
    },
    data () {
      return {
        moment: moment,
        codLang: sessionStorage.getItem('codLang'),
        prodotti: [],
        buonirit: [],
        testata: {},
        tabProdotti: {
          currentPage: 1,
          pag_for: 5,
          nrPages: 0,
          nrItems: 0
        },
        tabActive: '0',
        ordine: {},
        loading: true
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.codLang = sessionStorage.getItem('codLang')
      })
    },
    activated: function () {
      this.init()
    },
    methods: {
      init: function () {
        this.$nextTick(() => {
          if (sessionStorage.hasOwnProperty(this.prefixApp + '_ordine')) {
            this.$set(this, 'ordine', JSON.parse(sessionStorage.getItem(this.prefixApp + '_ordine')))
            this.$emit('setShowNuovo', this.ordine.ifNuovo)
            if (this.$route.params.afterSave) {
              this.$set(this, 'tabActive', '1')
            }
            this.$set(this, 'loading', true)
            this.listBuoniRit()
            this.loadOrdine()
          } else {
            this.$router.push({name: this.prefixApp + 'Ordini'})
          }
        })
      },
      getBuonoRit: function (buono) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringAcquisti + 'print/ordini/buonodiritiro' +
                '?codLang=' + this.codLang +
                '&country=' + this.ordine.country +
                '&codForn=' + this.ordine.codForn +
                '&numBuono=' + buono.numBuono +
                '&appName=' + ((this.prefixApp === 'SO') ? 'SituazioneOrdini' : 'WebBuoniDiRitiro') +
                '&token=' + response.body.wsToken
              )
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      changePageProdotti: function (page) {
        this.$set(this.tabProdotti, 'currentPage', page)
        this.loadOrdine()
      },
      loadOrdine: function () {
        this.$http.get('situazioneordini/' + this.prefixApp.toLowerCase() + '/ordine', {
          params: {
            codLang: this.codLang,
            country: this.ordine.country,
            codForn: this.ordine.codForn,
            codSoc: this.ordine.codSoc,
            codMag: this.ordine.codMag,
            annoOrd: this.ordine.annoOrd,
            numOrd: this.ordine.numOrd,
            pag_action: (this.tabProdotti.currentPage > 1) ? 'NEXT' : 'BEGIN',
            pag_from: this.tabProdotti.currentPage,
            pag_for: this.tabProdotti.pag_for
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'testata', response.body.attrib)
              this.$set(this, 'prodotti', response.body.data)

              if (this.tabProdotti.currentPage === 1) {
                this.$set(this.tabProdotti, 'nrPages', parseInt(response.body.attrib.pages))
                this.$set(this.tabProdotti, 'nrItems', parseInt(response.body.attrib.size))
              }
            } else {
              this.$set(this, 'testata', {})
              this.$set(this, 'prodotti', [])
              this.$set(this.tabProdotti, 'nrPages', 0)
              this.$set(this.tabProdotti, 'nrItems', 0)
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'loading', false)
          })
      },
      returnGgScaduto: function (datCons) {
        let diffDays = this.returnGgScadutoTooltip(datCons)

        if (diffDays > 999) {
          return '99+'
        }
        return diffDays
      },
      returnGgScadutoTooltip: function (datCons) {
        let today = moment()
        let dataConsegna = moment(datCons, 'DDMMYYYY')
        let diffDays = today.diff(dataConsegna, 'days')

        return (diffDays > 0) ? diffDays : ''
      },
      listBuoniRit: function () {
        this.$http.get('situazioneordini/' + this.prefixApp.toLowerCase() + '/buonirit', {
          params: {
            codLang: this.codLang,
            country: this.ordine.country,
            codForn: this.ordine.codForn,
            codSoc: this.ordine.codSoc,
            codMag: this.ordine.codMag,
            annoOrd: this.ordine.annoOrd,
            numOrd: this.ordine.numOrd
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'buonirit', response.body.data)
            } else {
              this.$set(this, 'buonirit', [])
              if (response.body.msg[0].msgId !== '2020') {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            }
            this.$set(this, 'loading', false)
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .dettaglio-ordine {
    .header-tab {
      height: 70px;
      text-align: center;
      margin-bottom: 5px;
      .my-label {
        line-height: 55px;
        height: 45px;
        .set-font(@color: @oroRiva; @size: 22px; @family: 'os-semibolditalic');
        letter-spacing: 2px;
      }
      .sotto-label {
        .set-font(@size: 15px; @family: 'os-lightitalic');
        letter-spacing: 1px;
        height: 25px;
      }
    }
    .testata-ordine {
      height: auto;
      .colonna-md {
        margin-left: 1px;
      }
      .colonna {
        height: 100%;
        margin-top: 20px;
        .blocco {
          .elemento {
            height: auto;
            .testata-label {
              .set-font(@size: 11px, @color: @greenRiva, @family: 'os-semibold');
              display: inline;
              text-align: right;
              line-height: 16px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              text-transform: uppercase;
              letter-spacing: 1px;
              padding: 5px 10px;
            }
            .testata-value {
              .set-font(@color: #454848, @size: 12px);
              display: inline;
              word-wrap: break-word;
              white-space: normal;
              line-height: 16px;
              border-left: 1px solid @oroRiva;
              padding: 5px 10px;
              letter-spacing: 1px;
              .icona {
                color: #54e912;
              }
            }
          }
        }
        .secondo-blocco {
          margin-top: 20px;
        }
      }
    }
    .el-tabs {
      margin-top: 40px;
      .el-table {
        .el-table__body {
          .ggScaduto {
            height: 22px !important;
            line-height: 22px;
            .set-font(@size: 12px, @color: #454848, @weight: bold);
            .el-badge__content.is-fixed {
              right: -5px;
              top: 11px;
            }
            .el-badge__content {
              height: 21px;
              width: 21px;
              border-radius: 10px;
              line-height: 17px;
              padding: 0;
              background-color: #e58e13;
              .set-font(@size: 10px, @color: @white);
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Fornitura/SituazioneOrdini/DettaglioOrdine.vue